import { Pipe, PipeTransform } from '@angular/core';
import { ITagModel } from '@shared/models/tag.model';

@Pipe({
    name: 'formatTags'
})
export class FormatTagsPipe implements PipeTransform {
    transform(tags: ITagModel[], language: string): any {
        let formattedTags = '';

        tags.forEach((tag, index) => {
            if (tag.translations?.find(x => x.languageId === language)?.value) {
                formattedTags += tag.translations?.find(x => x.languageId === language)?.value;
            } else {
                formattedTags += tag.translations[0]?.value;
            }
            if (index !== tags?.length-1) {
                formattedTags += ', ';
            }
        });

        return formattedTags;
    }
}
